import { inject, Injectable, signal, WritableSignal } from '@angular/core';
import { UserService } from '../../api/mylb/services/user.service';
import { take } from 'rxjs';

export interface IUserImageState {
	userID: number;
	image: string | undefined;
	initials: string | undefined;
	state: 'loading' | 'loaded' | 'error';
}

@Injectable({
	providedIn: 'root'
})
export class UserIconService {
	private _userService: UserService = inject(UserService);

	public userImageUrlState: WritableSignal<{ [userID: number]: IUserImageState }> = signal<{ [userID: number]: IUserImageState }>({});

	loadUserImage(userID: number): void {
		const existingUserImageState = this.userImageUrlState()[userID];

		if (!existingUserImageState) {
			const userImageState: IUserImageState = { userID, image: undefined, initials: undefined, state: 'loading' };
			this.userImageUrlState.set({ ...this.userImageUrlState(), [userID]: userImageState });

			this._userService
				.getUserImage(userID)
				.pipe(take(1))
				.subscribe({
					next: (response) => {
						const userImageState: IUserImageState = {
							userID: response.userID,
							image: response.image,
							initials: response.initials,
							state: 'loaded'
						};
						this.userImageUrlState.set({ ...this.userImageUrlState(), [userID]: userImageState });
					},
					error: () => {
						const userImageState: IUserImageState = { userID, image: undefined, initials: undefined, state: 'error' };
						this.userImageUrlState.set({ ...this.userImageUrlState(), [userID]: userImageState });
					}
				});
		}
	}
}
